// src/components/GalleryModal.js
import React from "react";
import { Modal, Button } from "react-bootstrap";
import Gallery from "devextreme-react/gallery";

const GalleryModal = ({ show, onHide, title, images, onExpand }) => {
  return (
    <Modal size="lg" show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Location: {title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ height: "520px", width: "100%" }}>
          <Gallery
            id="gallery"
            dataSource={images}
            height={540}
            slideshowDelay={0}
            showNavButtons={true}
            showIndicator={true}
            onItemClick={(e) => onExpand(e.itemData)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GalleryModal;
